import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  button: {
    composes: ['fs14', 'text-left', 'is-block'],
  },
});

const RegionButtonComponent = React.memo(({ label }) => {
  const classes = useStyles();
  return (
    <button
      className={classnames(
        classes.button,
        'smart-maps-trophies-region-button'
      )}
      type="button">
      <span>{label}</span>
    </button>
  );
});

RegionButtonComponent.propTypes = {
  label: PropTypes.string.isRequired,
};

RegionButtonComponent.displayName = 'RegionButtonComponent';

export default RegionButtonComponent;
